// useCollectionHandlers.js - Collection modal handlers
import { useModal } from '../contexts/ModalContext';
import { useNotification } from '../contexts/NotificationContext';

export const useCollectionHandlers = ({
  userCollectionItems,
  addToCollectionWithRelease,
  removeFromCollection,
  loadUserCollection,
}) => {
  const modal = useModal();
  const { showError } = useNotification();

  // Collection modal handlers
  const handleCollectionModalClick = movie => {
    // Always open the unified collection modal that shows all releases
    modal.openUnifiedCollectionModal(movie, userCollectionItems);
  };

  const handleCollectionReleaseSelected = async (
    releaseDisplayId,
    personalNotes = '',
    shouldCloseModal = false
  ) => {
    try {
      const result = await addToCollectionWithRelease(releaseDisplayId, personalNotes);

      if (result.success) {
        // Only close modal if explicitly requested (for old add mode)
        if (shouldCloseModal) {
          modal.closeModal('addToCollection');
        }
        // Reload collection to get updated data
        loadUserCollection();
      } else {
        showError('Error adding to collection: ' + result.error);
      }
    } catch (error) {
      console.error('Error adding to collection:', error);
      showError('Error adding to collection');
    }
  };

  const handleRemoveFromCollection = async (collectionItemId, shouldCloseModal = false) => {
    try {
      const result = await removeFromCollection(collectionItemId);

      if (result.success) {
        // Only close modal if explicitly requested
        if (shouldCloseModal) {
          modal.closeModal('addToCollection');
        }
        // Reload collection to get updated data
        loadUserCollection();
      } else {
        showError('Error removing from collection: ' + result.error);
      }
    } catch (error) {
      console.error('Error removing from collection:', error);
      showError('Error removing from collection');
    }
  };

  const handleCloseCollectionModal = () => {
    modal.closeModal('addToCollection');
  };

  return {
    handleCollectionModalClick,
    handleCollectionReleaseSelected,
    handleRemoveFromCollection,
    handleCloseCollectionModal,
  };
};
